// src/common/components/cartModal/components/deliveryTimeSelector/DeliveryTimeSelector.tsx
import React, { useState, useEffect } from "react";
import { MdArrowForward } from "react-icons/md";
import { useTheme } from "../../../../hooks/useTheme";
import styles from "./DeliveryTimeSelector.module.scss";

interface DeliveryTimeSelectorProps {
  displayText: string;
  pickerVisible: boolean;
  minimumDate: Date;
  onPress: () => void;
  onClose: () => void;
  onSelect: (date?: Date) => void;
  isTimeAvailable: (date: Date) => boolean;
}

// Форматирование даты для datetime-local input (локальное время)
const formatLocalDateTime = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const DeliveryTimeSelector: React.FC<DeliveryTimeSelectorProps> = ({
  displayText,
  pickerVisible,
  minimumDate,
  onPress,
  onClose,
  onSelect,
  isTimeAvailable,
}) => {
  const { theme } = useTheme();
  const [selectedDate, setSelectedDate] = useState<Date>(minimumDate);
  const [isValid, setIsValid] = useState<boolean>(true);

  useEffect(() => {
    const available = isTimeAvailable(selectedDate);
    console.log("🔄 DeliveryTimeSelector isValid check:", {
      selectedDate: selectedDate.toISOString(),
      selectedDateLocal: selectedDate.toString(),
      available,
      minimumDate: minimumDate.toISOString(),
    });
    setIsValid(available);
  }, [selectedDate, isTimeAvailable, minimumDate]);

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = new Date(e.target.value);
    console.log("📝 handleDateChange:", {
      value: e.target.value,
      date: date.toISOString(),
      dateLocal: date.toString(),
    });
    setSelectedDate(date);
  };

  const handleConfirm = () => {
    if (isValid) {
      onSelect(selectedDate);
      onClose();
    }
  };

  const handleCancel = () => {
    setSelectedDate(minimumDate);
    setIsValid(isTimeAvailable(minimumDate));
    onClose();
  };

  return (
    <div className={styles.container}>
      <span className={styles.label} style={{ color: theme.textSecondary }}>
        ⏰ Время получения
      </span>

      <button className={styles.selector} onClick={onPress}>
        <span className={styles.text} style={{ color: theme.text }}>
          {displayText}
        </span>
        <MdArrowForward size={18} color={theme.textSecondary} />
      </button>

      {pickerVisible && (
        <div className={styles.pickerOverlay} onClick={onClose}>
          <div
            className={styles.pickerModal}
            onClick={(e) => e.stopPropagation()}
          >
            <h4 className={styles.pickerTitle} style={{ color: theme.text }}>
              Выберите время получения
            </h4>

            <input
              type="datetime-local"
              className={styles.pickerInput}
              value={formatLocalDateTime(selectedDate)}
              min={formatLocalDateTime(minimumDate)}
              onChange={handleDateChange}
              style={{
                backgroundColor: theme.card,
                borderColor: theme.border,
                color: theme.text,
              }}
            />

            {!isValid && (
              <p className={styles.errorText} style={{ color: theme.danger }}>
                ⚠️ В это время мы не работаем. Выберите другое время!
              </p>
            )}

            <div className={styles.pickerActions}>
              <button className={styles.cancelButton} onClick={handleCancel}>
                Отмена
              </button>
              <button
                className={`${styles.confirmButton} ${!isValid ? styles.disabled : ""}`}
                onClick={handleConfirm}
                disabled={!isValid}
                style={{
                  opacity: isValid ? 1 : 0.5,
                  cursor: isValid ? "pointer" : "not-allowed",
                }}
              >
                "Подтвердить"
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
